export default __webpack_public_path__ + "static/media/003-lista.c07a0269.png";